import { Component, ElementRef, OnInit, ViewChild, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HandleUploadService } from '../../services/handle-upload.service';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent implements OnInit {

  uploadModalRef: any = null;
  uploadLabel: string = 'Event Recording';
  @ViewChild('uploadDataModal', { static: false }) uploadDataModal!: ElementRef;
  uploadDataForm!:FormGroup;
  submitUploadDataForm: boolean = false;
  processing: boolean = false;
  @Input('refData') refData: any;
  @Input('refType') refType: string = '';
  @Input('refIndex') refIndex: number = 0;
  @Input('processingStatus') processingStatus: boolean = false;
  @Input('processingCompleted') processingCompleted: boolean = false;
  @Input('refPage') refPage: string = '';

  /**
   * Output emitter to emit post data after form submission
   */
  @Output() postDataEmitter = new EventEmitter<any>();

  constructor(private modalService: NgbModal, private handleUploadService: HandleUploadService, private fb:FormBuilder) { }

  ngOnInit() {
  }

  /**
   * To detect changes in input properties
   * @param changes - SimpleChanges object to detect changes in input properties
   */
  ngOnChanges(changes: SimpleChanges) {
    if('processingCompleted' in changes && changes['processingCompleted'].currentValue == true) {      
      if(this.uploadModalRef) {
        this.closeUploadDataModal();
      }
    }
  }

  /**
   * To handle file upload
   * @param projectWebinar - project webinar object
   */
  onUploadFile() {
    this.initUploadDataForm();
    this.openUploadDataModal();
  }

  /**
   * To initialize upload data form
   */
  initUploadDataForm() {
    this.uploadDataForm = this.fb.group({
      event_id: [this.refData._id ? this.refData._id : this.refData.webinar_id, Validators.required],
      event_type: [this.refData.event_type ? this.refData.event_type : 'webinar', Validators.required],
      event_file: ['', Validators.required],
    });

    if(this.refData.event_type && this.refData.event_type == 'booked_slot') {
      this.uploadDataForm.patchValue({ event_id: this.refData.slot_booking_id });
    }

    //SHARE FORM WITH CHILD COMPONENT
    this.handleUploadService.addForm = this.uploadDataForm;
  }

  /**
   * To open upload data modal
   */
  openUploadDataModal() {
    this.uploadModalRef = this.modalService.open(this.uploadDataModal, { size: 'lg', backdrop: 'static' });
  }

  /**
   * To close upload data modal
   */
  closeUploadDataModal() {
    this.resetUploadDataForm();
    return;
  }

  /**
   * To save explanation data
   */
  onSaveFile() {
    this.submitUploadDataForm = true;

    //SEND FORM SUBMIT STATUS TO CHILD COMPONENT
    this.handleUploadService.sendSubmitFormStatus({ status: true, formSubmitStatus: this.submitUploadDataForm });

    if (this.uploadDataForm.invalid) {
      return false;
    }

    const postData: any = {};
    postData['event_id'] = this.uploadDataForm.value.event_id;
    postData['event_type'] = this.uploadDataForm.value.event_type;
    let eventFile = this.uploadDataForm.value.event_file;
    eventFile = eventFile.split(':::');
    postData['event_file'] = eventFile[0];
    postData['event_file_path'] = eventFile[1];

    // Emit the postData using the output emitter
    this.postDataEmitter.emit({status: true, postData: postData, refType: this.refType, refIndex: this.refIndex});
  }

  /**
   * To reset upload data action item form
   */
  resetUploadDataForm() {
    this.submitUploadDataForm = false;

    this.handleUploadService.sendSubmitFormStatus({ status: true, formSubmitStatus: this.submitUploadDataForm });
    this.handleUploadService.addForm = null;
    this.handleUploadService.allUploadedFiles = [];
    this.handleUploadService.allDeletedFiles = [];

    this.uploadDataForm.reset();
    this.uploadModalRef.close();
  }
}
